import { createSlice } from "@reduxjs/toolkit";
import { getContactUsById, updatecontactUsById, deletecontactUs,createcontactUs,getAllcontactUs } from "../../API/FormsData/ContactUs";

const initialState = {
    getallcontactUs: [],
    loading: false,
    error: null,
    totalPages: 0,
    currentPage: 1,
};

const contactUsSlice = createSlice({
  name: "ContactUs",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getContactUsById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getContactUsById.fulfilled, (state, action) => {
        state.loading = false;
        state.getcontactus = [action.payload]; // Flat contactUs object array
        state.error = null;
      })
      .addCase(getContactUsById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updatecontactUsById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updatecontactUsById.fulfilled, (state, action) => {
        state.loading = false;
        state.updatecontactUs = [action.payload]; // Flat contactUs object array
        state.error = null;
      })
      .addCase(updatecontactUsById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deletecontactUs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deletecontactUs.fulfilled, (state, action) => {
        state.loading = false;
        state.deletecontactUs = [action.payload]; // Flat contactUs object array
        state.error = null;
      })
      .addCase(deletecontactUs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getAllcontactUs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllcontactUs.fulfilled, (state, action) => {
        state.loading = false;
        state.getallcontactUs = action.payload.data;
        state.totalPages = action.payload.totalPages;
        state.currentPage = action.payload.page;
      })
      .addCase(getAllcontactUs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(createcontactUs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createcontactUs.fulfilled, (state, action) => {
        state.loading = false;
        state.createcontactUs = [action.payload]; // Flat contactUs object array
        state.error = null;
      })
      .addCase(createcontactUs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default contactUsSlice.reducer;